import { useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useMutation } from '@apollo/client';
import SpinnerOverlay from '../../../common/spinner/spinner';
import { notifySuccess } from '../../../../services/notification';
import { AddIcon, CancelIcon } from '../../../common/icons';
import PhoneDetails, { PhoneHandler } from '../../../org/contact-info/org-phone/phone-details';
import { CREATE_POSITION_CONTACT_PHONE, GET_POSITION_CONTACT_PHONES } from '../../../../graphql/contact-gql';
import Button from '../../../common/button';

type PhoneCreateProps = {
    positionId: number;
    isRole: boolean;
    isOpen: boolean;
    toggle: () => void;
}

const PhoneCreate = (props: PhoneCreateProps) => {
    const {isOpen, toggle, positionId, isRole } = props

    const contactRef = useRef<PhoneHandler>(null)
    const [createContactPhone, { loading }] = useMutation(CREATE_POSITION_CONTACT_PHONE)

    const [validated, setValidated] = useState<boolean>(false)

    const onCreateContactPhone = () => {
        if (contactRef.current && !contactRef.current.validate(true)) {
            return
        }

        let contactPhoneInput = contactRef.current && contactRef.current.getContactPhone()
        createContactPhone({
            variables: {
                positionId: positionId,
                input: contactPhoneInput
            },
            refetchQueries: [{
                query: GET_POSITION_CONTACT_PHONES,
                variables: { positionId: positionId }
            }],
            awaitRefetchQueries: true,
            onCompleted: () => {
                toggle()
                notifySuccess()
            }
        })
    }

    const onChange = () => {
        setValidated(!!contactRef.current?.validate(false))
    }

    return (<>
        {loading && <SpinnerOverlay />}
        <Modal size="lg" isOpen={isOpen} toggle={toggle} scrollable backdrop="static" autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>Add a {isRole ? 'Role' : 'Position'} Phone Number</ModalHeader>
            <ModalBody>
                <PhoneDetails ref={contactRef} isOrgPhone={false} onChange={onChange} autoFocus={true}/>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onCreateContactPhone} disabled={!validated}><AddIcon/>Add</Button>
                <Button color="secondary" onClick={toggle}><CancelIcon/>Cancel</Button>
            </ModalFooter>
        </Modal>
        </>
  )
}

export default PhoneCreate
